<template>
  <div id="app">
  <Navigation @langChange="updateLang" :web-data="webData"></Navigation>
    <transition name="fadeIn" mode="out-in">
      <router-view :web-data="webData" :key="webData.key"/>
    </transition>
  </div>
</template>

<script>
  import Navigation from "./components/Navigation";

  export default {
    name: 'APP',
    data () {
      return {
        logoColorState: true,
        webData: {}
      }
    },
    components: {Navigation},
    beforeMount () {
      this.$store.commit('setWebLang', 'HR');
      this.webData = this.$store.getters.activeLang;
      console.log('webdata: ', this.webData);
    },
    methods: {
      updateLang () {
        this.webData = this.$store.getters.activeLang;
        this.$forceUpdate();
        console.log('web: ', this.webData);
      }
    }
  }
</script>

<style>
  @font-face {
    font-family: 'Roboto-Light';
    src: url('./assets/fonts/Roboto-Light.eot'); /* IE9 Compat Modes */
    src: url('./assets/fonts/Roboto-Light.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
    url('./assets/fonts/Roboto-Light.woff') format('woff'), /* Modern Browsers */
    url('./assets/fonts/Roboto-Light.ttf')  format('truetype'); /* Safari, Android, iOS */
  }
  @font-face {
    font-family: 'Poppins';
    src: url('./assets/fonts/Poppins-Light.ttf')  format('truetype'); /* Safari, Android, iOS */
  }
  * {
   margin: 0;
    padding: 0;
  }
#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 100;
  font-size: 14px;
  line-height: 24px;
  text-transform: none;
  color: rgb(112, 112, 112);
}
  h1, h2, h3, h4, h5, h6 {
    font-family: "Roboto-Light",serif !important;
    font-weight: 100;
  }
  a, p {
    font-family: Poppins, serif;
  }

  ul {
    list-style-type: none;
  }

  .clearfix:before, .clearfix:after, .dl-horizontal dd:before, .dl-horizontal dd:after, .container:before, .container:after, .container-fluid:before, .container-fluid:after, .row:before, .row:after, .form-horizontal .form-group:before, .form-horizontal .form-group:after, .btn-toolbar:before, .btn-toolbar:after, .btn-group-vertical>.btn-group:before, .btn-group-vertical>.btn-group:after, .nav:before, .nav:after, .navbar:before, .navbar:after, .navbar-header:before, .navbar-header:after, .navbar-collapse:before, .navbar-collapse:after, .pager:before, .pager:after, .panel-body:before, .panel-body:after, .modal-header:before, .modal-header:after, .modal-footer:before, .modal-footer:after, .column-inner:before, .column-inner:after {
    display: table;
    content: '';
  }
  a:hover {
    text-decoration: none !important;
  }
  @media (min-width: 1200px) {
    .headline-container h1 {
      font-size: 70px;
      line-height: 74px;
    }
    .slide-text-container h2 {
      font-size: 48px;
      line-height: 48px;
    }
    .page-inner-wrapper .container-fluid {
      padding: 0 100px;
    }
    #project-cards .card-columns .card {
      width: 500px;
      height: 280px;
    }
    #project-cards .card-img-top {
      height: 280px;
    }
    #project-cards .card-columns {
      padding: 0 100px;
    }
  }
  @media (min-width: 992px) {
    .home-goto-btn  {
      font-size: 4em;
      right: 40px;
    }
    .slide-text-container {
      padding: 0 100px 0 50px;
    }
    .page-inner-wrapper .container-fluid {
      padding: 0 40px;
    }
    .chess-table .d-table-cell .text-cell, .chess-table .d-table-cell .icon-cell {
      width: 50%;
    }
    .spacer-lg {
      height: 80px;
    }
    div.text-module.module-space {
      padding: 60px 0;
    }
    #fullName, #email, #message {
      width: 100%;
    }
  }
  @media (min-width: 768px) {
    .chess-table {
      display: table;
    }
    .chess-table .d-table-cell {
      vertical-align: middle;
      width: 50%;
    }
    .chess-table-textbox.textbox-left {
      padding: 50px 40px 50px 10px;
    }
    .chess-table-textbox.textbox-right {
      padding: 50px 10px 50px 40px;
    }
    div.card-body.text-center h5 {
      font-size: 20px;
    }
    .col-display {
      display: inline-block;
    }
    #slide-3 .card {
      height: 685px;
    }
    .module-icon-container {
      left: 0;
    }
    .module-icon-container .icon-inner-container {
      font-size: 2.5em;
    }
    .p-text p {
      font-size: 18px;
    }
    .form-direction {
      flex-direction: row;
    }
    #slide-3 .card .card-body img {
      width: 50%;
    }
  }
  @media (min-width: 576px) {

  }
  @media (max-width: 1200px) {
    .headline-container h1 {
      font-size: 60px;
      line-height: 54px;
    }
    .slide-text-container h2 {
      font-size: 44px;
      line-height: 45px;
    }
    .page-inner-wrapper .container-fluid {
      padding: 0 60px;
    }
    #project-cards .card-columns .card {
      width: 350px;
      height: 240px;
    }
    #project-cards .card-img-top {
      height: 240px;
    }
    #project-module {
      padding: 0 !important;
    }
  }
  @media (max-width: 992px) {
    .headline-container h1 {
      font-size: 50px;
      line-height: 54px;
    }
    .slide-text-container h2 {
      font-size: 38px;
      line-height: 38px;
    }
    .home-goto-btn  {
      font-size: 3.5em;
      right: 32px;
    }
    .slide-text-container {
      padding: 0 70px 0 38px;
    }
    .chess-table .d-table-cell.text-cell {
      width: 80% !important;
    }
    .chess-table .d-table-cell.icon-cell {
      width: 20% !important;
    }
    .spacer-lg {
      height: 0;
    }
    div.text-module.module-space {
      padding: 38px 0;
    }
    #project-cards .card-columns {
      padding: 0;
    }
    #project-cards .card-columns .card {
      width: 280px;
      height: 200px;
      margin-right: 10px;
    }
    #project-cards .card-img-top {
      height: 200px;
    }
    #fullName, #email, #message {
      width: 90%;
    }
  }
  @media (max-width: 768px) {
    .chess-table .d-table-cell {
      width: 100%;
    }
    .chess-table {
      display: grid;
    }
    .chess-table-textbox.textbox-left, .chess-table-textbox.textbox-right {
      padding: 50px 0;
    }
    .headline-container h1 {
      font-size: 38px;
      line-height: 43px;
    }
    .slide-text-container h2 {
      font-size: 30px;
      line-height: 34px;
    }
    div.card-body.text-center h5 {
      font-size: 17px;
    }
    .col-display {
      display: block;
      width: 100%;
    }
    #slide-3 .overlay .container .column-inner {
      width: 100%;
    }
    #slide-3 .card .card-body img {
      width: 12%;
    }
    #slide-3 .card {
      height: 188px;
      margin-bottom: 15px;
    }
    #slide-3 .card .card-body {
      padding: .67rem
    }
    #slide-3 .card .card-body h5 {
      margin-bottom: 10px;
    }
    .home-goto-btn  {
      font-size: 3em;
      right: 25px;
    }
    .slide-text-container {
      padding: 0 40px 0 10px;
    }
    .module-icon-container {
      left: 13px;
    }
    .module-icon-container .icon-inner-container {
      font-size: 2em;
    }
    .p-text p {
      font-size: 16px;
    }
    div.text-module.module-space {
      padding: 20px 0;
    }
    #project-cards .card-columns .card {
      width: 240px;
      height: 180px;
      margin-right: 10px;
    }
    #project-cards .card-img-top {
      height: 180px;
    }
    .form-direction {
      flex-direction: column;
    }
  }
  @media (max-width: 576px) {
    .headline-container h1 {
      font-size: 30px;
      line-height: 32px;
    }
    .slide-text-container h2 {
      font-size: 23px;
      line-height: 30px;
    }
    #slide-3 .card {
      height: 180px;
    }
    #slide-3 .card .card-body {
      padding: .47rem
    }
    #slide-3 .card .card-body h5 {
      margin-bottom: 5px;
    }
    .home-goto-btn  {
      font-size: 2.5em;
      right: 18px;
    }
    .slide-text-container {
      padding: 0 28px 0 10px;
    }
    .p-text p {
      font-size: 14px;
    }
    div.text-module.module-space {
      padding: 10px 0;
    }
    #project-cards .card-columns .card {
      width: 210px;
      height: 155px;
      margin-right: 10px;
    }
    #project-cards .card-img-top {
      height: 155px;
    }
  }
  @media (max-width: 450px) {
    #slide-3 .card {
      height: 170px;
    }
    .home-goto-btn  {
      font-size: 2.2em;
      right: 12px;
    }
    .slide-text-container {
      padding: 0 18px 0 10px;
    }
    #project-cards .card-columns .card {
      width: 180px;
      height: 120px;
    }
    #project-cards .card-img-top {
      height: 120px;
    }
  }
  .fadeIn-enter-active, .fadeIn-leave-active {
    transition: all 1.5s;
  }
  .fadeIn-enter, .fadeIn-leave-to {
    opacity: 0;
  }
  .fadeIn-enter-to, .fadeIn-leave {
    opacity: 1;
  }
</style>
